<script>
import Button from "@/shared/ui/button/Button.vue";

export default {
  name: "BottomSheet",
  components: { Button },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    height: {
      type: String,
      default: "50%",
    },
    maxWidth: {
      type: String,
      default: "900px",
    },
  },
  emits: ["update:modelValue", "close"],
  methods: {
    close() {
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    onOverlayClick() {
      this.close();
    },
  },
};
</script>

<template>
  <transition name="bottom-sheet">
    <div v-if="modelValue" class="bottom-sheet">
      <div class="overlay" @click="onOverlayClick"></div>
      <div class="sheet" :style="{ height, maxWidth }">
        <div class="sheet-header">
          <div class="title">{{ title }}</div>
          <Button variant="ghost" class="close" type="button" @click="close">
            <svg-icon name="huge-close" class="w-5 h-5" />
          </Button>
        </div>
        <div class="sheet-body">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped lang="scss">
.bottom-sheet {
  @apply fixed inset-0 z-50;
}

.overlay {
  @apply absolute inset-0 bg-black/40;
}

.sheet {
  @apply absolute left-0 right-0 bottom-0 bg-card rounded-t-3xl;
  @apply w-full mx-auto;
  @apply flex flex-col;
  box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.08);
}

.sheet-header {
  @apply flex items-center justify-between px-6 py-4 border-b;
  border-color: rgba(10, 12, 17, 0.06);
}

.title {
  @apply text-base font-semibold text-foreground;
}

.close {
  @apply w-9 h-9 flex items-center justify-center rounded-full;
  @apply text-muted-foreground hover:bg-muted;
}

.sheet-body {
  @apply flex-1 overflow-y-auto px-6 py-6;
}

.bottom-sheet-enter-active,
.bottom-sheet-leave-active {
  transition: opacity 0.2s ease;
}

.bottom-sheet-enter-from,
.bottom-sheet-leave-to {
  opacity: 0;
}

.bottom-sheet-enter-active .sheet,
.bottom-sheet-leave-active .sheet {
  transition: transform 0.25s ease;
}

.bottom-sheet-enter-from .sheet,
.bottom-sheet-leave-to .sheet {
  transform: translateY(100%);
}
</style>
